import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface IncomingQuoteItem {
  id: string;
  title: string;
  quantity: number;
  unit: string;
  brand: string;
  sku?: string;
  image?: string;
}

export interface IncomingQuote {
  id?: string;
  name: string;
  company?: string;
  email: string;
  phone: string;
  note?: string;
  items: IncomingQuoteItem[];
  status: 'new' | 'read' | 'converted';
  convertedQuotationId?: string;
  createdAt?: any;
}

const COLLECTION_NAME = 'incoming_quotes';

/**
 * Add a new quote request from the public website
 */
export const addIncomingQuote = async (data: Omit<IncomingQuote, 'id' | 'status' | 'createdAt'>) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...data,
      status: 'new',
      createdAt: serverTimestamp(),
    });
    return docRef.id;
  } catch (error) {
    console.error('Error adding incoming quote: ', error);
    throw error;
  }
};

/**
 * Listen for incoming quotes in real-time (for Admin Dashboard)
 */
export const subscribeToIncomingQuotes = (callback: (quotes: IncomingQuote[]) => void) => {
  const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snapshot) => {
    const quotes: IncomingQuote[] = [];
    snapshot.forEach((doc) => {
      quotes.push({ id: doc.id, ...doc.data() } as IncomingQuote);
    });
    callback(quotes);
  });
};

/**
 * Mark a quote request as read
 */
export const markIncomingQuoteAsRead = async (id: string) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, { status: 'read' });
  } catch (error) {
    console.error('Error updating incoming quote status: ', error);
    throw error;
  }
};

/**
 * Web talebi teklife dönüştürüldüğünde işaretle
 */
export const markIncomingQuoteAsConverted = async (
  id: string,
  quotationId: string
) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      status: 'converted',
      convertedQuotationId: quotationId,
    });
  } catch (error) {
    console.error('Error marking incoming quote as converted: ', error);
    throw error;
  }
};

/**
 * Delete a quote request entirely
 */
export const deleteIncomingQuote = async (id: string) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error('Error deleting incoming quote: ', error);
    throw error;
  }
};
